import React from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

const styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none',
        }
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px',
        }
    },
};

class TextEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            textLetter: props.textLetter,
            originalText: props.textLetter,
        };

        this.toggleDialog = this.toggleDialog.bind(this);
        this.changeTextLetterText = this.changeTextLetterText.bind(this);
        this.updateGazetters = this.updateGazetters.bind(this);
        this.returnOriginalText = this.returnOriginalText.bind(this);
    }

    returnOriginalText() {
        this.setState({
            textLetter: this.state.originalText,
        });
    }

    updateGazetters() {
        const { textLetter } = this.state;

        this.toggleDialog();

        if (this.props.typeAnnotations === 'gazetter') {
            this.props.updatePostAnnotations(textLetter);
        } else {
            this.props.updatePostGazetters(textLetter);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { originalText } = this.state;

        if (originalText === '') {
            originalText = nextProps.textLetter;
        }

        this.setState({
            textLetter: nextProps.textLetter,
            originalText,
        });
    }

    changeTextLetterText(e) {
        this.setState({
            textLetter: e.target.value,
        });
    }

    toggleDialog() {
        this.setState({
            open: !this.state.open,
        });
    }
    
    render() {
        const { open, textLetter } = this.state;

        const actions = [
            <FlatButton
                label='RE-ANNOTATE'
                primary
                onClick={this.updateGazetters}
            />,
            <FlatButton
                label='RETURN ORIGINAL TEXT'
                primary
                onClick={this.returnOriginalText}
            />,
            <FlatButton
                label='CLOSE'
                primary
                onClick={this.toggleDialog}
            />,
        ];
        return (
            <div className="btn">
                <RaisedButton
                    onClick={this.toggleDialog}
                    label='Editor'
                    labelStyle={styles.button.labelStyle}
                    style={styles.button.style}
                    buttonStyle={styles.button.buttonStyle}
                    primary
                />

                <Dialog
                    title='Edit letter text'
                    actions={actions}
                    contentStyle={styles.dialog.contentStyle}
                    open={open}
                    modal
                >
                    <textarea
                        style={styles.textarea.style}
                        value={textLetter}
                        onChange={this.changeTextLetterText}
                    />
                </Dialog>
            </div>

        );
    }
}

export default TextEditor;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Management/TextEditor.jsx